import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ParamServicesService } from 'src/app/services/param-services.service';

@Component({
  selector: 'app-container-card-product',
  templateUrl: './container-card-product.component.html',
  styleUrls: ['./container-card-product.component.scss'],
})
export class ContainerCardProductComponent implements OnInit, OnDestroy {
  @Input() product: any = undefined;
  @Input() loop: any = undefined;
  private _reloadObs: Subscription = new Subscription();

  constructor(
    public paramSv: ParamServicesService,
    // private cdr: ChangeDetectorRef
  ) {
    // this._reloadObs.add( this.paramSv.reload.subscribe(() => {
    //   this.cdr.detectChanges();
    // }) )
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
    this._reloadObs.unsubscribe();
  }
}
